<template>
  <div id="accordion" class="w-100">
    <div class="card">
    <div class="card-header" :id="'headingOne'+mykey">
      <h5 class="mb-0">
        <button
          class="btn btn-link "
          :class="open ? '' : 'collapsed'"
          data-toggle="collapse"
          :data-target="'#collapseOne'+mykey"
          aria-expanded="false"
          :aria-controls="'collapseOne'+mykey"
          @click="openNow()"
        >
         {{title}}
         <span v-html="titleHtml"></span>
        </button>
      </h5>
    </div>
      <div
        :id="'collapseOne'+mykey"
          :class="open ? 'show' : ''"
        class="collapse  p-4"
        :aria-labelledby="'headingOne'+mykey"
        data-parent="#accordion"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from "vue";


export default {
  data () {
    return {
      isOpen:false
    }
  },

  props: {
    title: String,
    titleHtml: String,
    mykey:Number,
    open:Boolean
  },

  created() {
    this.isOpen = this.open
  },
  methods:{
    openNow(){
      if(!this.isOpen){
        this.$emit("opennow")
        this.isOpen = true
      }else{
        this.isOpen = false
      }
    }
  }

};
</script>
